import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ImageNotSupportedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"image_not_supported"}/>
}
